import Task from '../../../types/api/task'
import { DesignerTasksTableRow } from '../types/table-row'
import { createNoShipmentHeaderRow, createShipmentHeaderRow } from './row-helpers'

type TaskGroup = {
    tasks: Task[]
    sortDate: number
    noShipment?: boolean
}

function groupTasks(tasks: Task[]): TaskGroup[] {
    const grouped: Record<string, Task[]> = {}
    const singles: Task[] = []

    for (const task of tasks) {
        if (task.shipment?.documentId) {
            const groupKey = task.shipment.documentId
            if (!grouped[groupKey]) grouped[groupKey] = []
            grouped[groupKey].push(task)
        } else {
            singles.push(task)
        }
    }

    const groups: TaskGroup[] = Object.values(grouped).map(arr => ({
        tasks: arr,
        sortDate: Math.max(...arr.map(t => new Date(t.createdAt).getTime())),
    }))

    if (singles.length > 0) {
        singles.sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
        groups.push({
            tasks: singles,
            sortDate: Math.max(...singles.map(t => new Date(t.createdAt).getTime())),
            noShipment: true,
        })
    }

    groups.sort((a, b) => b.sortDate - a.sortDate)
    return groups
}

export function buildDesignerTasksDataSource(tasks: Task[]): DesignerTasksTableRow[] {
    return groupTasks(tasks).flatMap((group): DesignerTasksTableRow[] => {
        if (group.noShipment) {
            return [createNoShipmentHeaderRow(), ...group.tasks]
        }

        const shipment = group.tasks[0]?.shipment

        if (shipment?.documentId) {
            return [createShipmentHeaderRow(shipment), ...group.tasks]
        }

        return group.tasks
    })
}
